export enum AnnotationFormatType {
    YOLO = "YOLO",
    COCO = "COCO",
    CSV = "CSV",
    JSON = "JSON",
    VOC = "VOC",
    VGG = "VGG"
}